import { CalendarToday, Person } from "@mui/icons-material"
import { Box } from "@mui/material"
import {
	MainDetailsCommonContainer,
	MainDetailsCommonContainerItems,
} from "./MainDetailsCommon"

export default function MainDetailsFooter({ data, children, noUsePaper }) {
	if (!data) return null

	return (
		<MainDetailsCommonContainer noUsePaper={noUsePaper}>
			<Box
				display={"flex"}
				gap={2}
				flexWrap="wrap"
				flexDirection={{ xs: "column", sm: "row" }}
			>
				<MainDetailsCommonContainerItems
					label="Creado Por"
					icon={Person}
					value={data.created_by_name}
				/>
				<MainDetailsCommonContainerItems
					label="Creado El"
					icon={CalendarToday}
					value={data.created_at}
				/>
				<MainDetailsCommonContainerItems
					label="Editado Por"
					icon={Person}
					value={data.updated_by_name}
				/>
				<MainDetailsCommonContainerItems
					label="Editado El"
					icon={CalendarToday}
					value={data.updated_at}
				/>
				{children}
			</Box>
		</MainDetailsCommonContainer>
	)
}
